function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplete2Fa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 77.5 40 C 77.5 19.289062 60.710938 2.5 40 2.5 C 19.289062 2.5 2.5 19.289062 2.5 40 C 2.5 60.710938 19.289062 77.5 40 77.5 C 60.710938 77.5 77.5 60.710938 77.5 40 Z M 77.5 40 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,53.725493%,48.235294%)",
      fillOpacity: 1
    },
    d: "M 40 2.5 C 19.289062 2.5 2.5 19.289062 2.5 40 C 2.5 60.710938 19.289062 77.5 40 77.5 C 60.710938 77.5 77.5 60.710938 77.5 40 C 77.5 19.289062 60.710938 2.5 40 2.5 Z M 31.28125 62.5 L 31.257812 62.476562 L 31.234375 62.5 L 13.75 44.5 L 22.535156 35.546875 L 31.257812 44.523438 L 57.507812 17.5 L 66.25 26.5 Z M 31.28125 62.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete2Fa);
export default __webpack_public_path__ + "static/media/complete2FA.761a29b8107801838fb5261842e31dc3.svg";
export { ForwardRef as ReactComponent };